// project-imports
import {
  ADD_BLOG_COMMENTS_BEGIN,
  ADD_BLOG_COMMENTS_FAILURE,
  ADD_BLOG_COMMENTS_SUCCESS,
  DELETE_BLOG_COMMENTS_BEGIN,
  DELETE_BLOG_COMMENTS_FAILURE,
  DELETE_BLOG_COMMENTS_SUCCESS,
  GET_BLOG_BEGIN,
  GET_BLOG_COMMENTS_BEGIN,
  GET_BLOG_COMMENTS_FAILURE,
  GET_BLOG_COMMENTS_SUCCESS,
  GET_BLOG_FAILURE,
  GET_BLOG_SUCCESS,
  GET_BLOG_USER_REACTION_BEIGN,
  GET_BLOG_USER_REACTION_FAILURE,
  GET_BLOG_USER_REACTION_SUCCESS,
  GLOBAL_SEARCH_BLOG_FAILURE,
  GLOBAL_SEARCH_BLOG_SUCCESS,
  PUT_BLOG_LIKES_BEGIN,
  PUT_BLOG_LIKES_FAILURE,
  PUT_BLOG_LIKES_SUCCESS,
  SET_BLOG_USER_REACTION_BEGIN,
  SET_BLOG_USER_REACTION_FAILURE,
  SET_BLOG_USER_REACTION_SUCCESS,
  UPDATE_BLOG_COMMENTS_BEGIN,
  UPDATE_BLOG_COMMENTS_FAILURE,
  UPDATE_BLOG_COMMENTS_SUCCESS,
} from "../constants/actions";
import { processCourseComments } from "../utils/course";

// State variable initialization
const initialState = {
  blogLoading: false,
  isLikeUpdating: false,
  blogError: null,
  blogs: [],
  comments: [],
  allComments: [],
  blogAllUserReactions: [],
  blogUserReactionsCount: [],
  filteredBlogs: [],
  searchTerm: null
};

const blogReducer = (state = initialState, action) => {

  if (action.type === GET_BLOG_BEGIN) {
    // Set loading state
    return {
      ...state,
      blogLoading: action.payload,
      blogError: null,
      searchTerm: null,
      filteredBlogs: []
    };
  }
  if (action.type === GET_BLOG_SUCCESS) {

    let data = [];
    let existingBlogs = [...state.blogs];

    ([...action.payload] || []).forEach((item) => {
      existingBlogs = existingBlogs.filter(
        (dataItem) => dataItem.id !== item.id
      );
      item.link = item.title;
      item.originalTitle = item.title;
      data.push(item);
    });
    const sortedBlogs = (data || [])?.sort((a, b) => new Date(b.blogDate || "").getTime() - new Date(a.blogDate || "").getTime());

    // Update state with all blogs
    return {
      ...state,
      blogLoading: false,
      blogs: JSON.parse(JSON.stringify(sortedBlogs)),
      filteredBlogs: [],
      blogError: null,
      searchTerm: null
    };
  }

  if (action.type === GLOBAL_SEARCH_BLOG_SUCCESS) {
    let filteredBlogs = [];
    let newTitle = "";
    const searchTerm = action.payload;
    let localState = state;

    // filtering search bar

    if (searchTerm && localState) {
      filteredBlogs = localState.blogs
        .filter((blog) =>
          blog?.isPublished === true && blog.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .map((blog) => {
          newTitle = blog.title.replace(
            new RegExp(searchTerm, "gi"),
            (match) =>
              `<mark style="background: #e7bd3c; color: white;">${match}</mark>`
          );

          return {
            ...blog,
            title: newTitle,
          };
        });
    } else {
      filteredBlogs = [];
    }

    // Update state with searched blog
    return {
      ...state,
      filteredBlogs: filteredBlogs,
      blogLoading: false,
      blogError: null,
      searchTerm: searchTerm,
    };
  }

  if (action.type === GLOBAL_SEARCH_BLOG_FAILURE) {
    // Set error state
    return {
      ...state,
      blogLoading: false,
      blogError: action.payload,
      searchTerm: null,
    };
  }

  if (action.type === GET_BLOG_FAILURE) {
    // Set error state
    return {
      ...state,
      blogLoading: false,
      blogError: action.payload,
      searchTerm: null,
      filteredBlogs: []
    };
  }

  if (action.type === PUT_BLOG_LIKES_BEGIN) {
    // Set loading state
    return {
      ...state,
      isLikeUpdating: action.payload,
      blogError: null,
    };
  }

  if (action.type === PUT_BLOG_LIKES_SUCCESS) {

    const existingPosts = state.blogs || [];

    const updatedBlogs = existingPosts.map((blog) => {

      if (action.payload && action.payload.success && blog?.id === action?.payload?.success[0]?.id) {
        return { ...blog, likes: action?.payload?.success[0]?.likes };
      }

      return blog;
    });

    // Update state with likes
    return {
      ...state,
      isLikeUpdating: false,
      blogError: null,
      filteredBlogs: [],
      blogs: JSON.parse(JSON.stringify(updatedBlogs)),
      searchTerm: null,
    };
  }

  if (action.type === PUT_BLOG_LIKES_FAILURE) {
    // Set error state
    return {
      ...state,
      isLikeUpdating: false,
      blogError: action.payload,
    };
  }


  if (action.type === GET_BLOG_COMMENTS_BEGIN) {
    // Set loading state
    return {
      ...state,
      blogLoading: action.payload,
      blogError: null,
    };
  }

  if (action.type === GET_BLOG_COMMENTS_SUCCESS) {

    const processedComments = processCourseComments(Array.isArray(action.payload) ? action.payload : []);

    // Update state with all comments
    return {
      ...state,
      blogLoading: false,
      blogError: null,
      comments: processedComments,
      allComments: Array.isArray(action.payload) ? action.payload : []
    };

  }

  if (action.type === GET_BLOG_COMMENTS_FAILURE) {
    // Set error state
    return {
      ...state,
      blogLoading: false,
      blogError: action.payload,
    };
  }

  if (action.type === ADD_BLOG_COMMENTS_BEGIN) {
    // Set loading state
    return {
      ...state,
      blogLoading: action.payload,
      blogError: null,
    };
  }

  if (action.type === ADD_BLOG_COMMENTS_SUCCESS) {

    let existingComments = [...(state?.allComments || [])];
    let successRecords = action?.payload?.success || [];
    let statusCode = action?.payload?.statusCode || 500;
    let errors = action?.payload?.failures?.errors || [];
    let updatedComments = [...existingComments, ...successRecords];

    updatedComments = updatedComments.map(comment =>
      comment.id === action.payload.id ? { ...action.payload } : comment
    );

    if (action?.payload?.id && !updatedComments.some(c => c.id === action.payload.id)) {
      updatedComments.push(action.payload);
    }

    const processedComments = processCourseComments([...updatedComments]);

    // Update state with new comments
    return {
      ...state,
      blogLoading: false,
      blogError: statusCode !== 200 ? (errors || []).map(item => item.message).join(",") : [],
      comments: processedComments,
      allComments: updatedComments
    };
  }

  if (action.type === ADD_BLOG_COMMENTS_FAILURE) {
    // Set error state
    return {
      ...state,
      blogLoading: false,
      blogError: action.payload,
    };
  }

  if (action.type === UPDATE_BLOG_COMMENTS_BEGIN) {
    // Set loading state
    return {
      ...state,
      blogLoading: action.payload,
      blogError: null
    };
  }

  if (action.type === UPDATE_BLOG_COMMENTS_SUCCESS) {

    let existingComments = [...(state.allComments || [])];
    let successRecords = action?.payload?.success || [];
    let statusCode = action?.payload?.statusCode || 500;
    let errors = action?.payload?.failures?.errors || [];

    const updatedComments = (successRecords ? successRecords : []).reduce((acc, item) => {

      const index = acc.findIndex((post) => post.id === item.id);
      if (index !== -1) {
        acc[index] = item;
      } else {
        acc.push(item);
      }

      return acc;
    }, [...existingComments]);

    const processedComments = processCourseComments([...updatedComments]);

    // Update state with updated comments
    return {
      ...state,
      blogLoading: false,
      blogError: statusCode !== 200 ? (errors || []).map(item => item.message).join(",") : [],
      comments: processedComments,
      allComments: updatedComments,
    };
  }

  if (action.type === UPDATE_BLOG_COMMENTS_FAILURE) {
    // Set error state
    return {
      ...state,
      blogLoading: false,
      blogError: action.payload,
    };
  }

  if (action.type === DELETE_BLOG_COMMENTS_BEGIN) {
    // Set loading state
    return {
      ...state,
      blogLoading: action.payload,
      blogError: null,
    };
  }

  if (action.type === DELETE_BLOG_COMMENTS_SUCCESS) {

    let existingComments = [...(state.allComments || [])];

    let updatedComments = [];

    if (action?.payload?.id) {
      updatedComments = existingComments.filter((item) => item.id !== action?.payload?.id)
    }

    const processedComments = processCourseComments([...updatedComments]);

    // Update state with deleted comments
    return {
      ...state,
      blogLoading: false,
      blogError: null,
      comments: processedComments,
      allComments: updatedComments
    };

  }

  if (action.type === DELETE_BLOG_COMMENTS_FAILURE) {
    // Set error state
    return {
      ...state,
      blogLoading: false,
      blogError: action.payload,
    };
  }

  if (action.type === SET_BLOG_USER_REACTION_BEGIN) {
    // Set loading state
    return {
      ...state,
      blogsLoading: action.payload,
      blogsError: null,
    };
  }

  if (action.type === SET_BLOG_USER_REACTION_SUCCESS) {

    // Update state with user reactions
    return {
      ...state,
      blogsLoading: false,
      blogsError: null,
    };
  }

  if (action.type === SET_BLOG_USER_REACTION_FAILURE) {
    // Set error state
    return {
      ...state,
      blogsLoading: false,
      blogsError: action.payload,
    };
  }

  if (action.type === GET_BLOG_USER_REACTION_BEIGN) {
    // Set loading state
    return {
      ...state,
      blogLoading: action.payload,
      blogError: null,
    };
  }

  if (action.type === GET_BLOG_USER_REACTION_SUCCESS) {

    let index = (state.blogAllUserReactions || []).findIndex(
      (item) => item.blogId === action.payload.blogId
    );

    let blogAllUserReactions = [...(state.blogAllUserReactions || [])];

    // All userReactions
    if (index === -1) {
      blogAllUserReactions.push({
        blogId: action.payload.blogId,
        userBlogReactions: action.payload.userBlogReactions,
      });
    } else {
      blogAllUserReactions[index] = {
        blogId: action.payload.blogId,
        userBlogReactions: action.payload.userBlogReactions,
      };
    }
    // fetching user reaction count start
    let blogSpecificUserReactions =
      blogAllUserReactions &&
      blogAllUserReactions.length &&
      blogAllUserReactions.map((blogReaction) => {
        let upvoteCountResponse = 0;
        let downvoteCountResponse = 0;
        let loveCountResponse = 0;
        let surprisedCountResponse = 0;

        blogReaction.userBlogReactions.forEach((userReaction) => {
          userReaction.userReactions.forEach((item) => {
            if (item["label"] === "Upvote") {
              upvoteCountResponse += item["count"];
            } else if (item["label"] === "Downvote") {
              downvoteCountResponse += item["count"];
            } else if (item["label"] === "Love") {
              loveCountResponse += item["count"];
            } else if (item["label"] === "Surprised") {
              surprisedCountResponse += item["count"];
            }
          });
        });

        // add to array
        return {
          blogId: blogReaction.blogId,
          blogUserReactionsCount: [
            {
              emoji: "/images/emoji/like.png",
              label: "Upvote",
              count: upvoteCountResponse,
              type: "positive",
            },
            {
              emoji: "/images/emoji/dislike.png",
              label: "Downvote",
              count: downvoteCountResponse,
              type: "negative",
            },
            {
              emoji: "/images/emoji/love.png",
              label: "Love",
              count: loveCountResponse,
              type: "positive",
            },
            {
              emoji: "/images/emoji/surprise.png",
              label: "Surprised",
              count: surprisedCountResponse,
              type: "positive",
            },
          ],
        };
      });

    // Update state with all user reactions
    return {
      ...state,
      blogLoading: false,
      blogAllUserReactions: blogAllUserReactions,
      blogUserReactionsCount: blogSpecificUserReactions,
      blogError: null,
    };
  }

  if (action.type === GET_BLOG_USER_REACTION_FAILURE) {
    // Set error state
    return {
      ...state,
      blogLoading: false,
      blogError: action.payload,
    };
  }

  return state;
};

export default blogReducer;
